export const content = {
    domain: "Opploans",
    footer: "oplloan.com",
    title1: "Need Money Now? Apply with Opploans",
  };
  